"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBooleanItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormEnumItem_1 = require("./FormEnumItem");
const FormBooleanItem = (props) => {
    // @ts-ignore
    return (0, jsx_runtime_1.jsx)(FormEnumItem_1.FormEnumItem, { options: [{ value: true, label: "Ano" }, { value: false, label: "Ne" }], ...props });
};
exports.FormBooleanItem = FormBooleanItem;
